import { VariantReader } from './index.js';

export function VariantProvider({ ssrVariants, children }) {
    if (ssrVariants && typeof ssrVariants === 'object') {
        VariantReader.importCache(ssrVariants);
    }
    return children;
}

export function useVariantContext() {
    return null;
}
